// Lógica del TecladoPin compartido (PIN central, 2026-10-21). Sin React ni DOM: se prueba con node --test.
// El componente (TecladoPin.jsx) solo pinta; aquí se decide qué hacer con cada tecla y con cada respuesta.
//
// Respuestas que entiende (las de hoy y la central), todas pasan por normalizarRespuesta:
//   acc_pin_verificar  { resultado: 'ok'|'invalido'|'bloqueado', intentos_restantes, espere_seg, ... }
//   cables / equipos   { ok: true } | { ok: false, error: 'invalido'|'bloqueado'|'sin_conexion'|'formato'|..., intentosRestantes, esperaSeg }
//   mantenimiento      'ok' | 'invalido' | 'error' | { resultado: 'bloqueado', espere }
//   marcas             { resultado, intentos, espere_seg, mensaje }

export const MAX_ESPERA_SEG = 24 * 3600;

export function agregarDigito(pin, d, max) {
  const actual = typeof pin === 'string' ? pin : '';
  if (!/^[0-9]$/.test(String(d))) return actual;
  if (actual.length >= max) return actual;
  return actual + String(d);
}

export function borrarDigito(pin) {
  return (typeof pin === 'string' ? pin : '').slice(0, -1);
}

const num = (v) => {
  if (v === null || v === undefined || v === '') return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

// Una sola forma: { resultado, intentosRestantes, esperaSeg, mensaje }.
export function normalizarRespuesta(r) {
  if (typeof r === 'string') return { resultado: r === 'ok' ? 'ok' : r === 'invalido' ? 'invalido' : 'error', intentosRestantes: null, esperaSeg: null, mensaje: '' };
  if (!r || typeof r !== 'object') return { resultado: 'error', intentosRestantes: null, esperaSeg: null, mensaje: '' };
  let resultado;
  if (typeof r.resultado === 'string') resultado = r.resultado;
  else if (r.ok === true) resultado = 'ok';
  else if (r.ok === false) resultado = typeof r.error === 'string' ? r.error : 'error';
  else resultado = 'error';
  if (!['ok', 'invalido', 'bloqueado', 'sin_conexion', 'formato', 'configuracion'].includes(resultado)) resultado = 'error';
  return {
    resultado,
    intentosRestantes: num(r.intentos_restantes ?? r.intentosRestantes ?? r.intentos),
    esperaSeg: num(r.espere_seg ?? r.esperaSeg ?? r.espere),
    mensaje: typeof r.mensaje === 'string' ? r.mensaje : '',
  };
}

// Bloqueo: lo dice el servidor, o se acabaron los intentos. Un PIN malo nunca deja la puerta abierta por un
// número raro: sin espera válida se bloquea 60 s (misma regla que cables).
export function esBloqueo(n) {
  return n.resultado === 'bloqueado' || (n.resultado === 'invalido' && n.intentosRestantes === 0);
}

export function esperaSegura(seg) {
  const s = Number(seg);
  return Number.isFinite(s) && s > 0 ? Math.min(Math.ceil(s), MAX_ESPERA_SEG) : 60;
}

export function textoEspera(seg) {
  const s = Math.max(1, Math.ceil(seg));
  if (s < 60) return `${s} ${s === 1 ? 'segundo' : 'segundos'}`;
  const m = Math.ceil(s / 60);
  if (m < 60) return `${m} ${m === 1 ? 'minuto' : 'minutos'}`;
  const h = Math.ceil(m / 60);
  return `${h} ${h === 1 ? 'hora' : 'horas'}`;
}

export function textoDigitos(min, max) {
  return min === max ? `${min} números` : `entre ${min} y ${max} números`;
}

// Mensaje para la persona (sin jerga). restanteSeg solo cuando hay bloqueo vigente.
export function mensajeRespuesta(n, { min = 4, max = 8, restanteSeg = 0 } = {}) {
  if (n.mensaje) return n.mensaje;
  if (restanteSeg > 0) {
    if (restanteSeg >= MAX_ESPERA_SEG) return 'PIN bloqueado. Pida a administración que lo desbloquee.';
    return `Demasiados intentos. Espere ${textoEspera(restanteSeg)}.`;
  }
  switch (n.resultado) {
    case 'invalido': {
      const k = n.intentosRestantes;
      if (k !== null && k > 0) return `PIN incorrecto. ${k === 1 ? 'Le queda 1 intento.' : `Le quedan ${k} intentos.`}`;
      return 'PIN incorrecto.';
    }
    case 'sin_conexion':
      return 'Sin conexión. El PIN necesita internet.';
    case 'formato':
      return `El PIN tiene ${textoDigitos(min, max)}.`;
    case 'configuracion':
      return 'El ingreso con PIN no está configurado. Avise a administración.';
    case 'bloqueado':
      return 'Demasiados intentos. Espere un momento.';
    default:
      return 'No se pudo revisar el PIN. Intente de nuevo.';
  }
}
